module.exports = require("@tiptap/extension-text-align");